import React from 'react';
import {
  Select,
  FormControl,
  InputLabel,
  OutlinedInput,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  formControl: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    minWidth: 120,
    display: 'flex',
    flexGrow: 1,
    textAlign: 'left',
  },
}));

export default function SimpleSelect({
  children,
  value,
  handleChange,
  label,
  name,
  containerStyle,
  open,
  setOpen,
  setClosed,
  noFloatingLabel,
  selectProps,
  isRequired,
  additionalMenuProps = {},
  error,
}) {
  const classes = useStyles();
  const inputLabel = React.useRef(null);
  const [labelWidth, setLabelWidth] = React.useState(0);
  React.useEffect(() => {
    if (!noFloatingLabel) setLabelWidth(inputLabel.current.offsetWidth);
  }, []);

  const handleClose = () => setClosed();

  const handleOpen = () => setOpen();

  return (
    <FormControl
      variant="outlined"
      className={classes.formControl}
      style={containerStyle}
      // error={error}
    >
      {!noFloatingLabel && (
        <InputLabel
          ref={inputLabel}
          htmlFor={`outlined-${name}-simple`}
          // error={error}
        >
          {label}
          {isRequired && <span style={{ color: 'red' }}> *</span>}
        </InputLabel>
      )}
      <Select
        MenuProps={{
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'center',
          },
          ...additionalMenuProps,
        }}
        displayEmpty={noFloatingLabel}
        renderValue={
          noFloatingLabel
            ? () => <div style={{ color: '#747375' }}>{label}</div>
            : null
        }
        value={value}
        onChange={handleChange}
        open={open}
        onClose={setClosed && handleClose}
        onOpen={setOpen && handleOpen}
        input={
          <OutlinedInput
            labelWidth={noFloatingLabel ? 0 : labelWidth}
            name={name}
            id={`outlined-${name}-simple`}
          />
        }
        {...selectProps}
      >
        {children}
      </Select>
    </FormControl>
  );
}
